import { alpha, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

import styled, { styledProps } from 'features/theme/styled';
import theme from 'features/theme/theme';

interface VrsCallCommentsButtonProps {
  icon: ReactNode;
  title: string;
  onClick: () => void;
  isChecked?: boolean;
}
export const VrsCallCommentsButton: FC<VrsCallCommentsButtonProps> = ({
  icon,
  title,
  onClick,
  isChecked,
}) => {
  return (
    <Container>
      <StyledButton title={title} $isChecked={isChecked} onClick={onClick}>
        {icon}
      </StyledButton>
      <Typography
        variant='body2'
        color={theme.palette.common.white}
        align='center'
        whiteSpace='pre-line'
        mt={6}
      >
        {title}
      </Typography>
    </Container>
  );
};

const StyledButton = styledProps('div')<{ $isChecked: boolean }>`
  width: 92px;
  height: 92px;
  padding: ${theme.spacing(15)};
  display: flex;
  align-items: center;
  border-radius: 16px;
  border: 1px solid ${theme.palette.grey[700]};
  cursor: pointer;
  svg {
    height: 38px;
    width: 38px;
  }

  ${({ $isChecked }) =>
    $isChecked
      ? `
  background-color: ${theme.palette.primary[500]};
    path {
       stroke: ${theme.palette.common.black};
    }
  `
      : `
    background-color: ${alpha(theme.palette.grey[900], 0.6)};
    &:hover {
    background-color: ${theme.palette.grey[900]};
  }
  `}
`;

const Container = styled('div')`
  max-width: 92px;
`;
